"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SaveAs = function SaveAs() {
  return _react2.default.createElement(
    "g",
    { id: "saveas" },
    _react2.default.createElement("path", {
      d: "M424.462151,377.300797 L424.462151,94.3227092 L330.139442,-4.21845682e-14 L47.1613546,-4.21845682e-14 C34.6525757,-0.0026426068 22.6553652,4.96528008 13.8103226,13.8103226 C4.96528008,22.6553652 -0.0026426068,34.6525757 7.15228151e-14,47.1613546 L7.15228151e-14,377.300797 C-0.0026426068,389.809576 4.96528008,401.806786 13.8103226,410.651829 C22.6553652,419.496871 34.6525757,424.464794 47.1613546,424.462151 L377.300797,424.462151 C403.315508,424.385573 424.385573,403.315508 424.462151,377.300797 L424.462151,377.300797 Z M212.231076,377.300797 C173.175082,377.300797 141.513944,345.639659 141.513944,306.583665 C141.513944,267.527672 173.175082,235.866534 212.231076,235.866534 C251.287069,235.866534 282.948207,267.527672 282.948207,306.583665 C282.966731,325.344687 275.522147,343.342631 262.256094,356.608684 C248.990042,369.874736 230.992098,377.319321 212.231076,377.300797 L212.231076,377.300797 Z M282.948207,141.484064 L47.1613546,141.484064 L47.1613546,47.1613546 L282.978088,47.1613546 L282.948207,141.484064 Z M460.557769,130.418327 L498.007968,168.635458 L498.007968,451.673307 C498.007968,477.609562 477.50996,499.601594 451.613546,499.601594 L121.513944,499.601594 C98.8247012,499.601594 80.0896414,483.247012 75.4880478,462.101594 C78.685259,462.330677 81.8027888,462.101594 84.6613546,462.101594 L414.741036,462.101594 C440.697211,462.101594 460.557769,440.657371 460.557769,414.760956 L460.557769,130.418327 Z",
      id: "Combined-Shape"
    })
  );
};

exports.default = SaveAs;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/SaveAs.js
// module id = 2983
// module chunks = 4